/* eslint-disable object-curly-newline */
import Home from '@/views/Home.vue';
import Error404 from '@/views/errors/Error404.vue';

/* Static */
const About = () => import(/* webpackChunkName: "static" */ '@/views/static/About');
const Contact = () => import(/* webpackChunkName: "static" */ '@/views/static/Contact');
const Privacy = () => import(/* webpackChunkName: "static" */ '@/views/static/Privacy');
const Terms = () => import(/* webpackChunkName: "static" */ '@/views/static/Terms');

/* Compare */
const CompareIndex = () => import(/* webpackChunkName: "compare" */ '@/views/compare/CompareIndex');
const CompareCategory = () => import(/* webpackChunkName: "compare" */ '@/views/compare/CompareCategory');

/* Finder */
const FinderIndex = () => import(/* webpackChunkName: "finder" */ '@/views/finder/FinderIndex');
const FinderList = () => import(/* webpackChunkName: "finder" */ '@/views/finder/FinderList');

/* Products */
const ProductListAll = () => import(/* webpackChunkName: "products" */ '@/views/products/ProductListAll');
const ProductListBrand = () => import(/* webpackChunkName: "products" */ '@/views/products/ProductListBrand');
const ProductListPrice = () => import(/* webpackChunkName: "products" */ '@/views/products/ProductListPrice');
const ProductListProcessor = () => import(/* webpackChunkName: "products" */ '@/views/products/ProductListProcessor');
const ProductListType = () => import(/* webpackChunkName: "products" */ '@/views/products/ProductListType');

/* Product */
const ProductDetails = () => import(/* webpackChunkName: "products" */ '@/views/products/ProductDetails');

/* Auth */
const Login = () => import(/* webpackChunkName: "auth" */ '@/views/auth/Login');
const Register = () => import(/* webpackChunkName: "auth" */ '@/views/auth/Register');
const Forgot = () => import(/* webpackChunkName: "reset" */ '@/views/auth/Forgot');
const Reset = () => import(/* webpackChunkName: "reset" */ '@/views/auth/Reset');

/* Dashboard */
const Dashboard = () => import(/* webpackChunkName: "member" */ '@/views/member/Dashboard');

const routes = [
  { path: '/', component: Home, name: 'Home' },

  { path: '/compare', component: CompareIndex, name: 'CompareIndex' },
  { path: '/compare/:category', component: CompareCategory, name: 'CompareCategory' },

  { path: '/product-finder', component: FinderIndex, name: 'FinderIndex' },

  { path: '/product-filter', component: FinderList, name: 'FinderList' },
  { path: '/products', component: ProductListAll, name: 'ProductsList' },
  { path: '/products/:slug', component: ProductListType, name: 'TypeList' },
  { path: '/brand/:slug', component: ProductListBrand, name: 'BrandList' },
  { path: '/price/:slug', component: ProductListPrice, name: 'PriceList' },
  { path: '/processor/:slug', component: ProductListProcessor, name: 'ProcessorList' },

  { path: '/product/:slug', component: ProductDetails, name: 'ProductDetails' },

  { path: '/login', component: Login, name: 'Login' },
  { path: '/register', component: Register, name: 'Register' },
  { path: '/forgot', component: Forgot, name: 'Forgot' },
  { path: '/reset', component: Reset, name: 'Reset', meta: { layout: 'simple' } },
  { path: '/dashboard', component: Dashboard, name: 'Dashboard', meta: { requireAuth: true } },

  { path: '/about', component: About, name: 'About' },
  { path: '/contact', component: Contact, name: 'Contact' },
  { path: '/privacy-policy', component: Privacy, name: 'Privacy' },
  { path: '/terms-condition', component: Terms, name: 'Terms' },

  { path: '*', component: Error404, name: 'Error404' },
];

export default routes;
